import { render } from "./DialogDettaglioManutenzione.vue?vue&type=template&id=6c83e95c"
import script from "./DialogDettaglioManutenzione.vue?vue&type=script&lang=js"
export * from "./DialogDettaglioManutenzione.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__